<template>
    <div class="search">

        <!-- <div class="title">
            <span class="tag is-large">
                {{ tagsArray }}
            </span>
        </div> -->
        <div class="title">
            Tag Search
        </div>
        <div class="">
            <div class="field is-grouped is-grouped-multiline">
                <div v-for="tag in tagsArray" :key="tag" class="control">
                    <div  class="tags has-addons">
                        <span :href="'/tag/' + tag" class="tag is-link is-large">{{ tag }}</span>
                        <a
                            @click="removeTag(tag, $event)"
                            class="tag is-delete is-large is-dark has-text-grey-light">
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <br>

        <resource-list
            :title="'Resources tagged with ' + this.tagsArray.join(' and ') + '.'"
            :is-loading="isLoading"
            :resources="normalizedResources"
        />

    </div>
</template>

<script>
import ResourceList from './ResourceList';
import axios from 'axios';
import _ from 'lodash';
import BoxResourceTransformer from '../BoxResourceTransformer';

let queryCache = {};

export default {
    props: {
        tags: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            isLoading: false,
            currentTags: this.tags || '',
            resources: []
        };
    },

    components: {
        'resource-list': ResourceList
    },

    created() {
        this.applyInitialSearchParams();
        window.addEventListener('popstate', this.historyHandler.bind(this));
        history.pushState({tags:this.currentTags}, '', '/tag/' + this.currentTags);
    },

    methods: {
        searchHandler() {
            this.getSearchResults(this.searchParams);
        },

        applyInitialSearchParams() {
            let params;
            this.searchHandler();
        },

        getSearchResults(searchParams) {
            const cache = this.checkCache(searchParams);

            if (cache !== false) {
                console.log('displaying results from cache');
                this.showResults(cache.data.files);
            } else {
                this.isLoading = true;
                axios.get('/search', {
                    params: searchParams
                })
                .then(response => {
                    this.storeResponse(searchParams, response);
                    this.showResults(response.data.files);
                });
            }
        },

        showResults(files) {
            this.isLoading = false;
            this.resources = files;
        },

        createKeyFromQuery(params) {
            return _.flatten(_.toPairs(params)).join(':');
        },

        checkCache(params) {
            const searchKey = this.createKeyFromQuery(params);
            if (!_.has(queryCache, searchKey)) {
                return false;
            } else {
                return queryCache[searchKey];
            }
        },

        storeResponse(params, response) {
            const searchKey = this.createKeyFromQuery(params);
            queryCache[searchKey] = response;
        },

        removeTag(tag, e) {
            if (e) e.preventDefault();
            if (this.tagsArray.length === 1) {
                document.location = '/';
            } else {
                this.currentTags = _.without(this.currentTags.split('+'), tag).join('+');
                history.pushState({tags:this.currentTags}, '', '/tag/' + this.currentTags);
                this.searchHandler();
            }
        },

        historyHandler(e) {
            if (e && e.state && e.state.tags) {
                this.currentTags = e.state.tags;
                this.searchHandler();
            }
        }
    },
    computed: {
        normalizedResources() {
            return _.map(this.resources, BoxResourceTransformer);
        },

        tagsArray() {
            return this.currentTags.split('+');
        },

        searchParams() {
            return {tags: this.currentTags};
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LibraryTagSearch.vue